"use client";

import MainHeader from "@/components/organisms/MainHeader";
import MainFooter from "@/components/organisms/MainFooter";
import PopupPromotion from "@/components/molecules/PopupPromotion";
import { useEffect, useState } from "react";

const MainLayout = ({ children }: { children: React.ReactNode }) => {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  if (!mounted) {
    return <div style={{ visibility: "hidden" }}>{children}</div>;
  }

  return (
    <div>
      <MainHeader />
      <main>{children}</main>
      <MainFooter />
      <PopupPromotion
        imageUrl={"/images/promotion_t5_2025.webp"}
        linkFanpage={"https://zalo.me/0869757033"}
        isHideButton={true}
      />
    </div>
  );
};

export default MainLayout;
